// extracted by mini-css-extract-plugin
export default {"nameField":"FieldStyle_nameField__hcwgM","actionsField":"FieldStyle_actionsField__SFw-w"};